export const  CHANGE_BORROWERID = "CHANGE_BORROWERID"
export const  CHANGE_BORROWERNAME = "CHANGE_BORROWERNAME"
export const  CHANGE_BORROWERLOANID = "CHANGE_BORROWERLOANID"